<template>
  <div class="PurcCard">
    <div class="PurcCard-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        购卡
      </div>
      <div class="PurcCard-caroel">
        <swiper :options="swiperOptions" ref="mySwiper">
          <swiper-slide><img src="../../public/obraoag/purcla.png" alt=""></swiper-slide>
          <swiper-slide><img src="../../public/obraoag/purclb.png" alt=""></swiper-slide>
          <swiper-slide><img src="../../public/obraoag/purclc.png" alt=""></swiper-slide>
        </swiper>
        <div class="PurcCard-tips">欧堡利亚 · 品类多元 · 专属客服 · 售后保障</div>
      </div>
      <div class="PurcCard-content" @click="purccent()"><img src="../../public/obraoag/purcld.png" alt=""></div>
    </div>
    <!-- 提示语 -->
    <div class="js_dialog" id="iosDialog2" :style="'display:' + purchint">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">暂不支持线上购卡,如需购卡请到网点购卡<br>客服电话: 4009284868</div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="purcclpt()" style="color: #f10100">知道了</a>
        </div>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      swiperOptions: {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        }
      },
      purchint: 'none'
    }
  },
  created () {
    
  },
  mounted () {

  },
  methods: {
    // 点击页面出现提示
    purccent(){
      // this.purchint = 'block';
    },
    // 点击知道了隐藏提示框
    purcclpt(){
      this.purchint = 'none';
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/PurcCard.css";
</style>